/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
  $('.custom-video button.play').click(function(){
		console.log('played');
		$(this).parent('.custom-video').find('video').trigger('play').prop('muted', false);
		$(this).hide();
		$('.custom-video .pause').fadeIn();
	  });

	  $('.custom-video button.pause').click(function(){
		$(this).parent('.custom-video').find('video').trigger('pause').prop('muted', true);
		$(this).hide();
		$('.custom-video .play').fadeIn();
	  });
	  
	  $('.custom-video button.sound').click(function(){
		$(this).parent('.custom-video').find('video').prop('muted', false); //unmute
		$(this).hide();
		$('.custom-video .mute').fadeIn();
	  });

	  $('.custom-video button.mute').click(function(){
		$(this).parent('.custom-video').find('video').prop('muted', true); //mute
		$(this).hide();
		$('.custom-video .sound').fadeIn();
	  });
	  
$('.filter_toggle').click(function(){
  
  $('.tags_show').slideToggle();
  $(this).find('.state').text(function(i, text){
          return text === "+" ? "-" : "+";
      })
  
});